import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IMGROUP_CUSTOM_ROUTE_CONFIG } from './custom-route-config';
import { CustomTodayModule } from './custom-today/custom-today.component';
import { MyBoardModule } from '@app/views/my-board/my-board.component';
import { FindInformationModule } from '@app/views/find-information/find-information.component';
import { CollaborationModule } from '@app/views/collaboration/collaboration.component';

@NgModule({
  imports: [
    CustomTodayModule,
    MyBoardModule,
    CollaborationModule,
    FindInformationModule,
    RouterModule.forRoot(IMGROUP_CUSTOM_ROUTE_CONFIG, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
})
  ]
})
export class IMGROUPAppRoutingModule { }
